import { Theme, createStyles, makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import * as React from 'react';
import { SvgLoading } from '../../Loaders';
import { DSButtonProps, DSButton } from '../DSButton';

export interface DSLoaderButtonProps extends DSButtonProps {
    loading?: boolean;
}

const useStyles = makeStyles((_theme: Theme) =>
    createStyles({
        hideChildren: {
            minWidth: '120px',
        },
    }),
);

// TODO: this should take advantage of MUI Svg utilities
export const DSLoaderButton: React.FC<DSLoaderButtonProps> = ({
    children,
    className,
    disabled,
    loading = false,
    ...rest
}) => {
    const classes = useStyles();
    return (
        <DSButton
            className={classNames({ [classes.hideChildren]: loading }, className)}
            disabled={loading || disabled}
            {...rest}
        >
            {loading && (
                <SvgLoading inline size="small" style={{ backgroundSize: '24px', height: '24px', width: '24px' }} />
            )}
            {!loading && children}
        </DSButton>
    );
};
DSLoaderButton.displayName = 'DSLoaderButton';
